import { createSelector } from '@reduxjs/toolkit';
import { List as ImmutableList } from 'immutable';
import { getSuggestedPrompts as getSuggestedPromptsOperator } from 'conversations-internal-schema/widget-data/operators/widgetDataGetters';
import { getLatestWidgetData } from './getLatestWidgetData';
const NO_PROMPTS = [];
export const getSuggestedPrompts = createSelector(getLatestWidgetData, widgetData => {
  const prompts = getSuggestedPromptsOperator(widgetData);
  if (Array.isArray(prompts)) {
    return prompts;
  }
  return ImmutableList.isList(prompts) ? prompts.toArray() : NO_PROMPTS;
});